<template>
    <div class="wrapper fill_wrap">
        <div class="fill_head_img">
            <img :src="head_second" alt="门票头图" v-if="head_second">
            <img src="../../assets/images/autoshow/level/top.png" alt="" v-else>
        </div>
        <!--        fill_head_img end-->
        <div class="fill_form">
            <h5 class="fill_form_h5">请输入寄票地址</h5>
            <p class="fill_form_p">完善邮寄门票信息，方便我们快递门票</p>
            <el-form ref="fill_form" :model="fill_form" style="margin-top: 15px;" :rules="rule">

                <el-form-item label="所在地区">
                    <el-input v-model="ticket_province" placeholder="所在地区" @click.native="change_city"></el-input>
                </el-form-item>
                <el-form-item prop="ticket_county" label="详细地址">
                    <el-input v-model="fill_form.ticket_county" placeholder="请填写门票邮寄详细地址"></el-input>
                </el-form-item>

                <div class="fill_form_icon">
                    <img src="../../assets/images/autoshow/level/car.jpg" alt="">
                </div>
                <el-form-item class="fill_btn">
                    <el-button @click="toSubmit()"
                    >立即提交</el-button>
                </el-form-item>
                <div class="fill_notes">请保持电话畅通，稍后会有工作人员与您联系</div>
            </el-form>

        </div>
        <!--        fill_form end-->
        <div class="fill_head_img">
            <img src="../../assets/images/autoshow/level/btm.png" alt="">
        </div>
    </div>
</template>

<script>
    import _request from "../../common/_request";
    import { Message } from "element-ui";
    import _config from "../../common/_config";
    import activities from "../../cache/activity";
    import lib_activity from "../../libs/lib_activity";
    import weui from "weui.js";//微信选择
    import "weui";

    let fill_form = {
        ticket_county: '',
        is_mode: '全款',
        is_sell: '首次购车'
    }
    export default {
        name: "level",
        data(){
            return{
                fill_form: fill_form,//表单信息

                rule: {
                    ticket_county: {
                        required: true,
                        message: "请输入邮寄地址",
                        trigger: "blur",
                    },
                },//表单验证

                //2022-10-26 -- 门票定位
                head_second: '',

                citys: [], // 全国城市

                ticket_province: '', //所在区县
                province_id: '',
                city_id: '',
                district_id: '',
                province: '',
                city: '',
                district: '',

                ak:'Um55dB3OefqO3NZw1yn4bWp6i6vrfuQC',//秘钥
           }
        },
        created() {
            if(activities.get()){
                this.head_second = activities.get().hasOwnProperty('head_second') ? activities.get().head_second : ''
            }else{
                this.head_second = ''
            };

            lib_activity.citys_all(this.init_city_all)
        },
        mounted() {
            //
            let that = this;
            let script = document.createElement("script");
            script.type = "text/javascript";
            script.src = "https://api.map.baidu.com/api?v=2.0&ak=" + this.ak + "&callback=init";
            document.head.appendChild(script);//插入此标签后 会在window上挂一BMap属性,此为跨域获取的数据
            setTimeout(() => {
                let geolocation = new BMap.Geolocation();
                geolocation.getCurrentPosition(a => {
                    let myGeo = new BMap.Geocoder();
                    myGeo.getLocation(new BMap.Point(a.point.lng, a.point.lat), function(result){
                        try{
                            that.province = result.addressComponents.province;
                            that.city = result.addressComponents.city;
                            that.district = result.addressComponents.district;
                            that.ticket_province = result.addressComponents.province + ' - ' + result.addressComponents.city + ' - ' + result.addressComponents.district;
                        }catch (e) {
                        }
                    })
                })
            },200)
        },
        methods: {
            toSubmit() {
                let that = this;
                this.$refs.fill_form.validate((valid) => {
                    if (valid) {
                        let data = {
                            id: this.$route.query.id,
                            tid: this.$route.query.tid,
                            form_address: this.province+this.city+this.district+this.fill_form.ticket_county,
                            form_sell: this.fill_form.is_sell,
                            form_stages: this.fill_form.is_mode,
                        };

                        _request._post(
                            data,
                            function (response) {
                                if (response.code !== _request.success) {
                                    Message.info(response.info);
                                }
                                Message.info(response.info);
                                setTimeout(() => {
                                    that.$router.push({
                                        path: "suc",
                                    });
                                }, 2000);
                            },
                            _config.common_supply
                        );
                    }
                });
            },

            //2022-10-25 -- 地址选择
            //城市选择
            init_city_all(data){
                this.citys = data;
            },

            get_province(){
                for(let i in this.citys){
                    if(this.province.indexOf(this.citys[i].name) == 0){
                        this.province_id = this.citys[i].id;
                        for(let j in this.citys[i].children){
                            if(this.city.indexOf(this.citys[i].children[j].name) == 0){
                                this.city_id = this.citys[i].children[j].id;
                                for(let y in this.citys[i].children[j].children){
                                    if(this.district.indexOf(this.citys[i].children[j].children[y].name) == 0){
                                        this.district_id = this.citys[i].children[j].children[y].id
                                    }
                                }
                            }
                        }
                    }
                }
            },
            change_city() {
                this.get_province();
                let that = this;
                let city_picker = [];
                for(let i = 0; i < this.citys.length; i++){
                    let level1 = {
                        label: this.citys[i].name,
                        value: this.citys[i].id,
                        children: []
                    };
                    for(let j = 0; j < this.citys[i].children.length; j ++){
                        let level2 = {
                            label: this.citys[i].children[j].name,
                            value: this.citys[i].children[j].id,
                            children: []
                        }
                        for(let k = 0; k < this.citys[i].children[j].children.length; k ++){
                            let level3 = {
                                label: this.citys[i].children[j].children[k].name,
                                value: this.citys[i].children[j].children[k].id,
                            }
                            level2.children.push(level3)
                        };

                        level1.children.push(level2)
                    };

                    city_picker.push(level1)
                }
                weui.picker(city_picker, {
                    defaultValue: [that.province_id, that.city_id, that.district_id],
                    onConfirm: function (res) {
                        that.province = res[0].label
                        that.city = res[1].label
                        that.district = res[2].label
                        that.ticket_province = res[0].label + ' - ' + res[1].label + ' - ' + res[2].label;
                    },
                    id: "datePicker",
                });
            },
        },
    }
</script>

<style scoped lang="less">
    @import "../../assets/style/autoshow/level/level";
    .is_display{
        display: none;
    }
    .fill_wrap{
        .fill_form{
            .fill_form_h5{
                font-size: 20px;
                width: 50%;
                margin: 0 auto;
                text-align: center;
                position: relative;
                padding: 5px 5px 10px;
            }
            .fill_form_h5:before{
                content: "";
                position: absolute;
                top: 50%;
                left: 0;
                transform: translate(0, -50%);
                width: 7px;
                height: 7px;
                border-radius: 50%;
                background-color: #ff4e3e;
            }
            .fill_form_h5:after{
                content: "";
                position: absolute;
                top: 50%;
                right: 0;
                transform: translate(0, -50%);
                width: 7px;
                height: 7px;
                border-radius: 50%;
                background-color: #ff4e3e;
            }
            .fill_form_p{
                border: 1px solid #ff6354;
                padding: 10px;
                color: #ff6354;
                margin: 0 auto;
                text-align: center;
            }
            .fill_form_icon{
                width: 100%;
                position: relative;
                img{
                    display: block;
                    margin: 0 auto;
                    width: 20%;
                }
            }
        }
    }
</style>
<style lang="less">
    .fill_form{
        .el-form-item__label{
            position: relative;
            padding-left: 15px;
            font-size: 12pt;
            margin-bottom: 5px;
        }
        .el-form-item__label:before{
            content: '';
            position: absolute;
            top: 25%;
            left: 0;
            width: 6px;
            height: 50%;
            background-color: #ff503e;
        }
        .el-radio-group{
            width: 77%;
            .el-radio-button{
                width: 50%;
                .el-radio-button__inner{
                    width: 100%;
                }
                .el-radio-button__orig-radio:checked+.el-radio-button__inner{
                    color: #333;
                    background-color: #fedada;
                    border-color: #fedada;
                }
            }
        }
    }
</style>
